import React from 'react'
import { Box, Typography, LinearProgress } from '@mui/material';

const ProgressBarShow = ({ progress }) => {
    function LinearProgressWithLabel(props) {
        return (
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Box sx={{ width: '100%', mr: 1 }}>
                    <LinearProgress variant='determinate' {...props} />
                </Box>
                <Box>
                    <Typography variant='body2' sx={{ color: 'text.secondary' }}>
                        {`${Math.round(props.value)}%`}
                    </Typography>
                </Box>
            </Box>
        );
    }
    return (
        <>
            <Box sx={{width: '100%'}}>
                <LinearProgressWithLabel value={progress} />
            </Box>
        </>
        
    );
}

export default ProgressBarShow